import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/footer';
import WbTemplate from './pages/WbTemplate';
import WbAddTemplate from './pages/WbAddTemplate';
import WbManageDealer from './pages/admin/WbManageDealer';
import WbTransactionDetail from './pages/admin/WbTransactionDetail';
import WbDeliveryReport from './pages/WbDeliveryReport';
import WbSessionRecievedReport from './pages/WbSessionRecievedReport';
import WbMisReport from './pages/WbMisReport';
import WbDealerwiseMisReport from './pages/WbDealerwiseMisReport';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/admin/adminDashboard';
import AdminGuard from './guards/AdminGuard';
// import Drag from './pages/Drag'
import WbLoginDetails from './pages/WbLoginDetails';
import Demo from './pages/Demo';
import Login from './pages/Login';
import { useUIContext } from './context';
import AuthGuard from './guards/authGuards';
import { Me } from './services/authServieces';
import UserTemplateReport from './pages/UserTemplateReport';
import IndividualTemplateReport from "./pages/IndividualTemplateReport"

import CreateFirstPage from './pages/CreateFirstPage';
import AdminPanel from './pages/mainquestion';
import Chatboat from './pages/Chatboat';
import CreateBot from './pages/CreateBot';
import Managebot from './pages/Managebot';

import Profile from './pages/profile';
import Changepassword from './pages/Changepassword';
import ManageWaba from './pages/admin/ManageWaba'

import EditGroupNumbers from './pages/EditGroupNumbers';

import DeliveryReport from './pages/admin/DeliveryReport';
import DeliveryReportDetail from './pages/admin/ReportDetails';
import TemplateReport from './pages/admin/TemplateReport';
import TemplateReportDetail from './pages/admin/TemplateReportDetail';
import MisReport from './pages/admin/MisReport';
import MisReportDetail from './pages/admin/MisReportDetails';
import SessionReport from './pages/admin/SessionReport';
import WalletAlert from './pages/admin/WalletAlert';
import CampaignReport from './pages/admin/CampaignReport';
import CampaignReportDetails from './pages/admin/CampaignReportDetails';
import ModifiedReport from './pages/admin/ModifiedReport';
import PendingReport from './pages/admin/PendingMessageAdmin';
import NotFound from './components/NotFound';
import CampaignWiseReport from './pages/CampaignWisereport';
import WpUserTransactionDetails from './pages/WpUsertransactionDetails';
import WpUserCampaignWiseTransactionDetails from './pages/WpCampaignWiseTransDetails';
import  PriceReport from './pages/PriceWiseReport'
import DeliveryNotification from './pages/DeliveryNotification';
import CustomerActivityReport from './pages/CustomerActivityReport';
import ManageUser from './pages/ManageUser.jsx';
import PaymentStatus from './pages/PaymentStatus.jsx'

import RegionWiseReport from './pages/admin/regionwise_report';
import ZoneWiseReport from './pages/admin/ZoneWiseReport';
import AreaWiseReport from './pages/admin/AreaWiseReport';
import MainealerWiseReport from './pages/admin/MainDealerWiseReport';
import DealerWiseReport from './pages/admin/DealerReport';




// OEM START

import WbManageOEM from './pages/admin/WpManageOEM'; // this is at admin section

import OemAdminDashboard from './pages/OEM/oemDashboard';
import OemDeliveryReport from './pages/OEM/oemDeliveryReport';
import OEMMisReport from './pages/OEM/OemMISReport';
import OEMWalletAlert from './pages/OEM/WalletData';
import TemplateWiseReport from './pages/OEM/OemTemplateWisedata';
import WbTemplateOEM from './pages/admin/WbTemplateOEM';
import AddInternationalPrice from './pages/admin/AddInternationalPrice';

import OemDetailedDeliveryReport from './pages/OEM/oemDetailedDeliveryReport'; //oem detailed report ...

import MisOemDetailedReport from './pages/OEM/OemMisdetailedReport'; // MIS Detailed Report for OEM 

import OemTemplateDetailedReport from './pages/OEM/OemTemplateWiseDetailedReport';
import ButtonClickReport from './pages/ButtonClickReport';
import AddCallback from './pages/admin/AddCallback';
import WbtemplateDetails from './pages/WbtemplateDetails';
import UserRights from './pages/admin/UserRights';
import AdminDetails from './pages/admin/AdminDetails';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import TermsConditions from './pages/TermsConditions.jsx';
// OEM END


const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Move useNavigate here
  const isPaymentStatusPage = location.pathname.startsWith('/payment-status');
  const showNavbarFooter = !['/login','/managebot','/notfound', '/privacy-policy','/terms-and-conditions'].includes(location.pathname) && !isPaymentStatusPage;
  const { isSidebarCollapsed,userType ,setUserType} = useUIContext();




  const excludedPaths = ['/login', '/managebot','/notfound', '/privacy-policy','/terms-and-conditions'];
  const isLoginPage = excludedPaths.includes(location.pathname) || isPaymentStatusPage;
  useEffect(() => {
    const userData =  JSON.parse(localStorage.getItem("user-cred"));
    const userType = userData?.user?.userType;
    setUserType(userType)
    if(
      location.pathname === "/" && 
      (userData?.user?.userType === "admin" || userData?.user?.userType === "super_admin")
    ){
      navigate('/admin');
    }
  }, [navigate]);

  return (
    <div id="page-body" className={!isSidebarCollapsed ? 'sidebar-collapsed' : ''}>
    <section className={isLoginPage ? '' : 'Contain'} id="Contain">
    {showNavbarFooter && <Header isSidebarCollapsed={isSidebarCollapsed} />}
      <div  className={isLoginPage ? '' : 'Dash_contain'}>
          <Routes>
            {/* Protected Routes */}
            {/* <Route path="/drag" element={<Drag />} /> */}
            <Route path='/payment-status/:id' element={<PaymentStatus/>}/>
            <Route path="/" element={<AuthGuard><Dashboard /></AuthGuard>} />
            <Route path="/wbtemplate" element={<AuthGuard><WbTemplate /></AuthGuard>} />
            <Route path="/wbtemplate-details" element={<AuthGuard><WbtemplateDetails /></AuthGuard>} />
            <Route path="/wbaddtemplate" element={<AuthGuard><WbAddTemplate /></AuthGuard>} />
            <Route path="/wbdeliveryreport" element={<AuthGuard><WbDeliveryReport /></AuthGuard>} />
            <Route path="/wbsessionrecievedreport" element={<AuthGuard><WbSessionRecievedReport /></AuthGuard>} />
            <Route path="/wbmisreport" element={<AuthGuard><WbMisReport /></AuthGuard>} />
            <Route path="/wbdealerwisemisreport" element={<AuthGuard><WbDealerwiseMisReport /></AuthGuard>} />
            <Route path="/wblogindetails" element={<AuthGuard><WbLoginDetails /></AuthGuard>} />
            <Route path="/demo" element={<AuthGuard><Demo /></AuthGuard>} />
            <Route path="/edit-group" element={<AuthGuard><EditGroupNumbers /></AuthGuard>} />
            <Route path="/price_report" element={<AuthGuard><PriceReport /></AuthGuard>} />
            <Route path="/template_report" element={<AuthGuard><UserTemplateReport /></AuthGuard>} />
            <Route path="/template_report/:templateId" element={<AuthGuard><IndividualTemplateReport /></AuthGuard>} />
            <Route path="/manage-user" element={<AuthGuard><ManageUser /></AuthGuard>} />
            
            <Route path="/delivery_notification" element={<AuthGuard><AdminGuard><DeliveryNotification /></AdminGuard></AuthGuard>} />
            


            <Route path="/userwalletdetails" element={<AuthGuard><WpUserTransactionDetails /></AuthGuard>} />


            <Route path="/customer_activity" element={<AuthGuard><CustomerActivityReport /></AuthGuard>} />

            <Route path="/campaignwise_transactions" element={<AuthGuard><WpUserCampaignWiseTransactionDetails /></AuthGuard>} />

            <Route path="/campaignwise_report" element={<AuthGuard><CampaignWiseReport /></AuthGuard>} />
            
            <Route path="/campaignwise_button_report" element={<AuthGuard><ButtonClickReport /></AuthGuard>} />


            {/* Admin Routes*/}
            <Route path="/admin" element={<AuthGuard><AdminGuard><AdminDashboard /></AdminGuard></AuthGuard>} />
            <Route path="/admin/transaction-details" element={<AuthGuard><AdminGuard><WbTransactionDetail /></AdminGuard></AuthGuard>} />
            <Route path="/admin/manage-dealer" element={<AuthGuard><AdminGuard><WbManageDealer /></AdminGuard></AuthGuard>} />
            <Route path="/admin/manage-waba" element={<AuthGuard><AdminGuard><ManageWaba/></AdminGuard></AuthGuard>} />
            <Route path="/admin/delivery-report" element={<AuthGuard><AdminGuard><DeliveryReport/></AdminGuard></AuthGuard>} />  
            <Route path="/admin/delivery-report/:userId" element={<AuthGuard><AdminGuard><DeliveryReportDetail/></AdminGuard></AuthGuard>} />
            <Route path="/admin/template-report" element={<AuthGuard><AdminGuard><TemplateReport/></AdminGuard></AuthGuard>} />
            <Route path="/admin/template-report/:templateId" element={<AuthGuard><AdminGuard><TemplateReportDetail/></AdminGuard></AuthGuard>} />
            <Route path="/admin/mis-report" element={<AuthGuard><AdminGuard><MisReport/></AdminGuard></AuthGuard>} />
            <Route path="/admin/mis-report/:userId" element={<AuthGuard><AdminGuard><MisReportDetail/></AdminGuard></AuthGuard>} />
            <Route path="/admin/session-report/" element={<AuthGuard><AdminGuard><SessionReport/></AdminGuard></AuthGuard>} />
            <Route path="/admin/campaign-report" element={<AuthGuard><AdminGuard><CampaignReport/></AdminGuard></AuthGuard>} />
            <Route path="/admin/campaign-report/:userId" element={<AuthGuard><AdminGuard><CampaignReportDetails/></AdminGuard></AuthGuard>} />
            <Route path="/admin/wallet-alert" element={<AuthGuard><AdminGuard><WalletAlert /></AdminGuard></AuthGuard>} />
            <Route path="/admin/updated-report" element={<AuthGuard><AdminGuard><ModifiedReport /></AdminGuard></AuthGuard>} />
            <Route path="/admin/user_rights" element={<AuthGuard><AdminGuard><UserRights /></AdminGuard></AuthGuard>} />
            <Route path="/admin/manage-admin" element={<AuthGuard><AdminGuard><AdminDetails /></AdminGuard></AuthGuard>} />
            <Route path="/admin/region-wise-report" element={<AuthGuard><AdminGuard><RegionWiseReport /></AdminGuard></AuthGuard>} />
            <Route path="/admin/zone-wise-report" element={<AuthGuard><AdminGuard><ZoneWiseReport /></AdminGuard></AuthGuard>} />
            <Route path="/admin/area-wise-report" element={<AuthGuard><AdminGuard><AreaWiseReport /></AdminGuard></AuthGuard>} />
          
            <Route path="/admin/main-dealer-wise-report" element={<AuthGuard><AdminGuard><MainealerWiseReport /></AdminGuard></AuthGuard>} />
            <Route path="/admin/dealer-wise-report" element={<AuthGuard><AdminGuard><DealerWiseReport /></AdminGuard></AuthGuard>} />
            {/* <Route path="/admin/manage-waba" element={<AuthGuard></AuthGuard>} /> */}


            <Route path="/admin/pending-report" element={<AuthGuard><AdminGuard><PendingReport/></AdminGuard></AuthGuard>} />

            <Route path="/admin/manage-oem" element={<AuthGuard><AdminGuard><WbManageOEM/></AdminGuard></AuthGuard>} />
            <Route path="/admin/template-oem" element={<AuthGuard><AdminGuard><WbTemplateOEM  /></AdminGuard></AuthGuard>} />
            <Route path="/admin/international-price" element={<AuthGuard><AdminGuard><AddInternationalPrice  /></AdminGuard></AuthGuard>} />
            <Route path="/admin/add-callback" element={<AuthGuard><AdminGuard><AddCallback /></AdminGuard></AuthGuard>} />

            <Route path="/createbot" element={<AuthGuard><CreateBot/></AuthGuard>} />
            <Route path="/createfirstPage" element={<CreateFirstPage />} />
            <Route path="/mainquestion" element={<AdminPanel />} />
            <Route path="/chatboat" element={<AuthGuard><Chatboat /></AuthGuard>} />
            <Route path="/managebot" element={<Managebot />} />

            <Route path="/profile" element={<AuthGuard><Profile/></AuthGuard>} />
            <Route path="/changepassword" element={<AuthGuard><Changepassword/></AuthGuard>} />


            {/* OEM dashboard */}

            <Route path="/oem-dashboard" element={<AuthGuard><OemAdminDashboard /></AuthGuard>} />


            <Route path="/oem/delivery-report" element={<AuthGuard><OemDeliveryReport /></AuthGuard>} />
            <Route path="/oem/delivery-report/:userId" element={<AuthGuard><OemDetailedDeliveryReport /></AuthGuard>} />


            <Route path="/oem/mis-report" element={<AuthGuard><OEMMisReport /></AuthGuard>} />
            <Route path="/oem/mis-report/:userId" element={<AuthGuard><MisOemDetailedReport /></AuthGuard>} />

            <Route path="/oem/wallet-data" element={<AuthGuard><OEMWalletAlert /></AuthGuard>} />

            <Route path="/oem/get-templatewisedata" element={<AuthGuard><TemplateWiseReport /></AuthGuard>} />

            <Route path='/oem/get-templatewisedata/:userId' element={<AuthGuard><OemTemplateDetailedReport/></AuthGuard>}/>
            {/* OEM data */}
            
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/notfound" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/notfound" />} />



          </Routes>
        </div>
      </section>
      {showNavbarFooter && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
};

export default App;
